import type * as React from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { ImagePasteProvider } from './image-field';
import { PresentationForm } from './presentation-form';

/**
 * Презентация-отчёт клиенту: ссылки на публикации → готовый файл по макету
 * «ШАБЛОНЫ ОТЧЕТА» в PDF, PowerPoint или SVG для Figma.
 *
 * Цифры по ссылкам считает InstaFarm: метрики поста Instagram отдаёт только
 * предъявителю ключа от аккаунта-владельца. По публикациям чужих пабликов
 * метрик нет ни у кого, кроме их владельца, — там человек приносит скриншот
 * статистики, и цифры с него снимает модель (см. api/insights-screen).
 */
export function PresentationReportCard(): React.ReactElement {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Презентация</CardTitle>
        <CardDescription>
          Ссылки на публикации — на выходе готовый отчёт клиенту.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {/*
          Ctrl+V с картинкой ловится на всю карточку, а не на каждое поле
          отдельно: браузер сообщает о вставке один раз на окно, и кто-то
          должен решить, какому из полей — логотипу, титулу, скриншоту
          статьи — картинка досталась (см. image-field).
        */}
        <ImagePasteProvider>
          <PresentationForm />
        </ImagePasteProvider>
      </CardContent>
    </Card>
  );
}
